import { render, staticRenderFns } from "./ConfirmInfo.vue?vue&type=template&id=74c78de5&"
import script from "./ConfirmInfo.vue?vue&type=script&lang=js&"
export * from "./ConfirmInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports